<template>
  <div class="border border-gray-300 p-3 rounded-xl relative h-52 flex flex-col justify-evenly">
    <!-- Microphone selector -->
    <DefaultDeviceSelector
      deviceIcon="/image/icons/microphone.svg"
      deviceType="Microphone"
      :deviceKind="DEVICES_KINDS.AUDIO_INPUT"
    ></DefaultDeviceSelector>

    <!-- Speaker selector -->
    <DefaultDeviceSelector
      deviceIcon="/image/icons/speaker.svg"
      deviceType="Speaker"
      :deviceKind="DEVICES_KINDS.AUDIO_OUTPUT"
    ></DefaultDeviceSelector>
  </div>
</template>
<script>
import DefaultDeviceSelector from '@/Components/DeviceAndSessionSetup/DefaultDeviceSelector.vue';
import { DEVICES_KINDS } from '@/Utils/vice-constants';

export default {
  name: 'DefaultDevicesSlot',
  components: {
    DefaultDeviceSelector,
  },
  setup() {
    return {
      DEVICES_KINDS,
    };
  },
};
</script>
<style scoped>
.device-type-label-regular {
  color: #881337;
  font-size: 16px;
}

.device-label-regular {
  font-size: 12px;
  color: #4b4b4b;
}
</style>
